import { render, staticRenderFns } from "./ListViewAtlasPlatform.vue?vue&type=template&id=7cd5e567"
import script from "./ListViewAtlasPlatform.vue?vue&type=script&lang=ts"
export * from "./ListViewAtlasPlatform.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports